import produce from "immer";
import { ServicesActions } from ".";
import { LoadState } from "../../constants/enums";
import {
  ASSIGN_MECHANIC,
  FETCH_SERVICE_FAILURE,
  FETCH_SERVICE_PROGRESS,
  FETCH_SERVICE_SUCCESS,
} from "../constants";
import { IStoreState } from "../initialStoreState";
import { initialServicesState } from "./types";

export const servicesReducer = (
  state: IStoreState["services"] = initialServicesState,
  action: ServicesActions
) => {
  switch (action.type) {
    case FETCH_SERVICE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.list.loadState = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SERVICE_SUCCESS: {
      const newState = produce(state, (draftState) => {
        draftState.list.services = action.payload.services;
        draftState.list.loadState = LoadState.Loaded;
        draftState.list.totalRecords = action.payload.totalRecords;
        draftState.list.totalAmount = action.payload.totalAmount;
      });
      return newState;
    }
    case FETCH_SERVICE_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.list.loadState = LoadState.Failed;
      });
      return newState;
    }
    case ASSIGN_MECHANIC: {
      const { complaintNumber, mechanicId } = action.payload;
      const newState = produce(state, (draftState) => {
        const complaint = draftState.list.services.find(
          (x) => x.complaint_no === complaintNumber
        );
        if (complaint) {
          complaint.assigned_mechanic_id = mechanicId;
        }
      });
      return newState;
    }
    default: {
      return state;
    }
  }
};
